import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Impressum = () => {
  return (
    <main className="pt-16 lg:pt-20">
      <section className="section-padding bg-white" data-testid="impressum-page">
        <div className="container-main">
          <div className="max-w-3xl mx-auto">
            <Link to="/" className="inline-flex items-center gap-2 text-slate-500 hover:text-[#0F172A] mb-8 transition-colors">
              <ArrowLeft className="w-4 h-4" />
              <span className="text-sm">Zurück zur Startseite</span>
            </Link>

            <h1 className="heading-lg text-[#0F172A] mb-8" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Impressum
            </h1>

            <div className="prose prose-slate max-w-none">
              <h2 className="text-xl font-semibold text-[#0F172A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Angaben gemäß § 5 TMG
              </h2>
              <p className="text-slate-600 mb-4">
                DSG Beteiligungs- und Verwaltungsgesellschaft mbH<br />
                (Betreiber von https://hospital-bess.de/)
              </p>

              <h2 className="text-xl font-semibold text-[#0F172A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Kontakt
              </h2>
              <p className="text-slate-600 mb-4">
                E-Mail: <a href="mailto:info@hospital-bess.de" className="text-[#10B981] hover:underline">info@hospital-bess.de</a>
              </p>
              <p className="text-slate-600 mb-4">
                Telefon:<br />
                +49 176 93127245<br />
                +49 30 71047955
              </p>

              <h2 className="text-xl font-semibold text-[#0F172A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Registereintrag
              </h2>
              <p className="text-slate-600 mb-4">
                Eintragung im Handelsregister
              </p>
              <p className="text-slate-600 mb-4">
                Registergericht: Amtsgericht Berlin-Charlottenburg<br />
                Registernummer: HRB 165868 B
              </p>

              <h2 className="text-xl font-semibold text-[#0F172A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
              </h2>
              <p className="text-slate-600 mb-4">
                DSG Beteiligungs- und Verwaltungsgesellschaft mbH
              </p>

              <h2 className="text-xl font-semibold text-[#0F172A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
                EU-Streitschlichtung
              </h2>
              <p className="text-slate-600 mb-4">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:<br />
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#10B981] hover:underline">
                  https://ec.europa.eu/consumers/odr/
                </a>
              </p>
              <p className="text-slate-600 mb-4">
                Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>

              <h2 className="text-xl font-semibold text-[#0F172A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Verbraucherstreitbeilegung / Universalschlichtungsstelle
              </h2>
              <p className="text-slate-600 mb-4">
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
              </p>

              <h2 className="text-xl font-semibold text-[#0F172A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Haftung für Inhalte
              </h2>
              <p className="text-slate-600 mb-4">
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
              </p>
              <p className="text-slate-600 mb-4">
                Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
              </p>

              <h2 className="text-xl font-semibold text-[#0F172A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Haftung für Links
              </h2>
              <p className="text-slate-600 mb-4">
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich.
              </p>
              <p className="text-slate-600 mb-4">
                Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
              </p>

              <h2 className="text-xl font-semibold text-[#0F172A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Urheberrecht
              </h2>
              <p className="text-slate-600 mb-4">
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
              </p>
              <p className="text-slate-600 mb-4">
                Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
              </p>

              <p className="text-slate-500 text-sm mt-12 pt-8 border-t border-slate-200">
                © 2026 DSG Beteiligungs- und Verwaltungsgesellschaft mbH — Design & Umsetzung: webionik
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};
